export default __webpack_public_path__ + "assets/images/rec-hand.png";